import { type NodeProps } from '@xyflow/react';
import { Triggers } from 'automations/types/automationConfig';
import { type TriggerNodeType } from 'automations/types/nodeTypes';

import useDealCreate from './useDealCreate';
import useDealUpdate from './useDealUpdate';
import useLeadActivityCreate from './useLeadActivityCreate';
import useLeadActivityUpdate from './useLeadActivityUpdate';
import useLeadCreate from './useLeadCreate';
import useLeadUpdate from './useLeadUpdate';
import useTaskCreate from './useTaskCreate';
import useUserCreate from './useUserCreate';
import useUserUpdate from './useUserUpdate';

export interface TriggerNodeReturnProps {
  icon: React.FC<any>;
  hasErrors: boolean;
  errorMessages: string[];
  handleEdit?: () => void;
  handleCopy?: () => void;
  AdditionalUI?: React.ReactNode;
}

export const TriggerNodeConfigFactory = {
  [Triggers.leadCreate]: useLeadCreate,
  [Triggers.leadUpdate]: useLeadUpdate,
  [Triggers.leadActivityCreate]: useLeadActivityCreate,
  [Triggers.leadActivityUpdate]: useLeadActivityUpdate,
  [Triggers.taskBaseCreate]: useTaskCreate,
  [Triggers.userCreate]: useUserCreate,
  [Triggers.userUpdate]: useUserUpdate,
  [Triggers.dealCreate]: useDealCreate,
  [Triggers.dealUpdate]: useDealUpdate,
};

export default function useTriggerNodeConfig(node: NodeProps<TriggerNodeType>): TriggerNodeReturnProps {
  const { data: { nodeSubType } } = node;

  return TriggerNodeConfigFactory[nodeSubType](node as any);
}
